import React from 'react';
import { PageHero } from '../components/PageHero';
export function TermsOfService() {
  return <div className="animate-fade-in-up" data-id="element-804">
      <PageHero title="Terms of Service" subtitle="Effective Date: February 9, 2026" data-id="element-805" />
      <section className="py-16 md:py-24 bg-white" data-id="element-806">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12 text-teal/80 leading-relaxed" data-id="element-807">
          <div className="space-y-4" data-id="element-808">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-809">
              Welcome to Arrive Psychotherapy & Wellness
            </h2>
            <p data-id="element-810">
              These Terms of Service govern your use of our website
              (arrivetherapy.ca) and the psychotherapy services provided by
              Jessica Ruppert, MA, RP (Qualifying). By booking a session, using
              our website, or receiving services from Arrive Psychotherapy &
              Wellness, you agree to these Terms.
            </p>
          </div>

          <div className="space-y-4" data-id="element-811">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-812">
              About Our Services
            </h2>
            <p data-id="element-813">
              Registered Psychotherapist (Qualifying) College of Registered
              Psychotherapists of Ontario (CRPO) Registration Number: 15311
            </p>
            <p data-id="element-814">
              As a Registered Psychotherapist (Qualifying), I am authorized to
              practice psychotherapy in Ontario under clinical supervision, as
              required by CRPO.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-815">
              <li data-id="element-816">
                <strong data-id="element-817">Services Offered:</strong> Individual psychotherapy for
                adults (ages 18+) experiencing anxiety and OCD, life
                transitions, people-pleasing patterns, comparison culture and
                social media pressure, and building authentic confidence.
              </li>
              <li data-id="element-818">
                <strong data-id="element-819">Therapeutic Approaches:</strong> CBT, DBT,
                mindfulness-based therapy, and narrative therapy, tailored to
                your specific needs.
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-820">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-821">
              Geographic and Service Limitations
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-822">
              <li data-id="element-823">
                <strong data-id="element-824">Ontario Residents Only:</strong> Our services are only
                available to residents of Ontario, Canada. By booking a session,
                you confirm that you are physically located in Ontario at the
                time of each session and are a resident of Ontario.
              </li>
              <li data-id="element-825">
                <strong data-id="element-826">Online Services Only:</strong> All therapy sessions are
                conducted online via secure video using our PHIPA-compliant
                telehealth platform (Owl Practice). We do not currently offer
                in-person sessions.
              </li>
              <li data-id="element-827">
                <strong data-id="element-828">Not a Crisis Service:</strong> Arrive Psychotherapy &
                Wellness does not provide crisis intervention or emergency
                services.
              </li>
            </ul>

            <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-400 mt-4" data-id="element-829">
              <h3 className="text-lg font-medium text-red-800 mb-2" data-id="element-830">
                If you are experiencing a mental health emergency or are in
                immediate danger:
              </h3>
              <ul className="list-disc pl-5 space-y-1 text-red-700" data-id="element-831">
                <li data-id="element-832">Call 911 or go to your nearest emergency department</li>
                <li data-id="element-833">Call the Ontario Crisis Line: 1-866-531-2600 (24/7)</li>
                <li data-id="element-834">
                  Call the Canada Suicide Prevention Service: 1-833-456-4566
                  (24/7)
                </li>
                <li data-id="element-835">Text "TALK" to 686868 for Kids Help Phone (ages 5-29)</li>
              </ul>
            </div>
            <p className="mt-4 text-sm italic" data-id="element-836">
              I do not provide after-hours crisis support. If you leave a
              voicemail or send an email, I will respond within 1-2 business
              days during regular business hours.
            </p>
          </div>

          <div className="space-y-4" data-id="element-837">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-838">
              Technology Requirements
            </h2>
            <p data-id="element-839">To participate in online therapy sessions, you must have:</p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-840">
              <li data-id="element-841">
                A reliable internet connection (minimum 5 Mbps recommended)
              </li>
              <li data-id="element-842">
                A computer, tablet, or smartphone with a camera and microphone
              </li>
              <li data-id="element-843">
                A web browser (Chrome, Safari, Firefox, or Edge - latest
                version)
              </li>
              <li data-id="element-844">A private, quiet space where you can speak freely</li>
            </ul>
            <p className="mt-2" data-id="element-845">
              <strong data-id="element-846">Your Responsibilities:</strong>
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-847">
              <li data-id="element-848">Ensuring your internet connection is stable</li>
              <li data-id="element-849">Testing your technology before sessions</li>
              <li data-id="element-850">Being in a private, confidential location during sessions</li>
              <li data-id="element-851">Notifying me if technology issues arise during a session</li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-852">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-853">
              Scheduling and Appointments
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-854">
              <li data-id="element-855">
                <strong data-id="element-856">Session Duration:</strong> Individual therapy sessions
                are 50 minutes in length.
              </li>
              <li data-id="element-857">
                <strong data-id="element-858">Cancellation Policy:</strong>
                <ul className="list-circle pl-5 mt-2 space-y-1" data-id="element-859">
                  <li data-id="element-860">
                    You may cancel or reschedule appointments at least 24 hours
                    in advance at no charge
                  </li>
                  <li data-id="element-861">
                    Cancellations made with less than 24 hours notice will be
                    charged the full session fee ($130)
                  </li>
                  <li data-id="element-862">
                    No-shows (failure to attend a scheduled session without
                    notice) will be charged the full session fee ($130)
                  </li>
                </ul>
              </li>
              <li data-id="element-863">
                Through your Owl Practice client portal, by email to
                jess@arrivetherapy.ca.
              </li>
              <li data-id="element-864">
                <strong data-id="element-865">Exceptions:</strong> Emergency situations (serious
                illness, family emergency, etc.) will be considered on a
                case-by-case basis.
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-866">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-867">
              Fees and Payment
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-868">
              <li data-id="element-869">
                <strong data-id="element-870">Individual Therapy:</strong> $130 per 50-minute session
              </li>
              <li data-id="element-871">
                <strong data-id="element-872">Payment Methods:</strong> Credit card (processed through
                Owl Practice) or E-transfer to contact@arrivetherapy.ca
              </li>
              <li data-id="element-873">
                <strong data-id="element-874">Receipts:</strong> You will receive an official receipt
                after each session that can be submitted to your insurance
                provider for potential reimbursement. I do not directly bill
                insurance companies.
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-875">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-876">
              Professional Boundaries
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-877">
              <li data-id="element-878">
                <strong data-id="element-879">Therapeutic Relationship:</strong> The relationship
                between us is a professional therapeutic relationship. Our
                interactions are limited to scheduled therapy sessions and brief
                communications related to scheduling or treatment.
              </li>
              <li data-id="element-880">
                <strong data-id="element-881">Confidentiality:</strong> Your privacy is protected by
                law. I will not disclose your personal health information
                without your consent, except:
                <ul className="list-circle pl-5 mt-2 space-y-1" data-id="element-882">
                  <li data-id="element-883">To my clinical supervisor (for supervision purposes)</li>
                  <li data-id="element-884">When required by law (court order, subpoena)</li>
                  <li data-id="element-885">To prevent serious and imminent harm to you or others</li>
                  <li data-id="element-886">As required by mandatory reporting laws</li>
                </ul>
              </li>
              <li data-id="element-887">
                <strong data-id="element-888">Communication Between Sessions:</strong> Email and
                secure messaging should be used only for scheduling, brief
                questions, or logistical matters. I respond to emails within 1-2
                business days during regular business hours. Therapy work should
                be reserved for scheduled sessions.
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-889">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-890">
              Informed Consent
            </h2>
            <p data-id="element-891">
              By using our services, you acknowledge and consent to the
              following:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-892">
              <li data-id="element-893">
                <strong data-id="element-894">Consent to Treatment:</strong> You understand the nature
                of psychotherapy services, potential benefits, and possible
                risks. You understand that therapy is a collaborative process
                and requires active participation. You understand that outcomes
                cannot be guaranteed. You are free to discontinue therapy at any
                time.
              </li>
              <li data-id="element-895">
                <strong data-id="element-896">Consent to Clinical Supervision:</strong> You understand
                that I practice under clinical supervision as required by CRPO.
                You consent to your clinical information being shared with my
                clinical supervisor. You have been provided with my supervisor's
                name and contact information. You understand you may contact my
                supervisor with questions or concerns.
              </li>
              <li data-id="element-897">
                <strong data-id="element-898">Consent to Virtual Therapy:</strong> You understand the
                risks and benefits of online therapy. You understand the
                technology requirements and your responsibilities. You consent
                to sessions being conducted via secure video platform.
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-899">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-900">
              Termination of Services
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-901">
              <li data-id="element-902">
                <strong data-id="element-903">By You:</strong> You may discontinue therapy at any time
                for any reason.
              </li>
              <li data-id="element-904">
                <strong data-id="element-905">By Me:</strong> I may discontinue services if you
                repeatedly miss sessions, have an outstanding balance, if I
                determine I am not the appropriate provider for your needs, or
                if continuing treatment would be clinically contraindicated. I
                will provide reasonable notice and appropriate referrals when
                possible.
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-906">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-907">
              Complaints and Dispute Resolution
            </h2>
            <p data-id="element-908">If you have concerns about the services provided:</p>
            <ol className="list-decimal pl-5 space-y-2" data-id="element-909">
              <li data-id="element-910">
                <strong data-id="element-911">Direct Discussion:</strong> I encourage you to raise
                concerns directly with me.
              </li>
              <li data-id="element-912">
                <strong data-id="element-913">Formal Complaint:</strong> File a complaint with the
                College of Registered Psychotherapists of Ontario:
                <div className="mt-2 pl-4 border-l-2 border-sage/30 text-sm" data-id="element-914">
                  375 University Avenue, Suite 800, Toronto, ON M5G 2J5
                  <br data-id="element-915" />
                  Phone: 416-479-4330 or 1-844-712-1364
                  <br data-id="element-916" />
                  Email: info@crpo.ca
                  <br data-id="element-917" />
                  Website:{' '}
                  <a href="https://www.crpo.ca" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline" data-id="element-918">
                    www.crpo.ca
                  </a>
                </div>
              </li>
            </ol>
          </div>

          <div className="space-y-4 border-t border-sage/20 pt-8" data-id="element-919">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-920">
              Contact Information
            </h2>
            <p data-id="element-921">Jessica Ruppert, MA, RP (Qualifying), jess@arrivetherapy.ca</p>
          </div>
        </div>
      </section>
    </div>;
}